import { roundedRect } from "@glideapps/glide-data-grid";
import { CanvasRenderingContext2DExtended } from "../CanvasRenderingContext2DExtended.js";
import { rowHeight } from "../types.js";
function renderHeaderCell({ ctx, rect, column, glideTheme, muiTheme, sortModel }) {
  if (!column) return;
  const { fontFamily, fontWeight, fontSize } = muiTheme.typography.h4;
  ctx.font = `${fontWeight} ${fontSize} ${fontFamily}`;
  ctx.fillStyle = muiTheme.palette.secondary.main;
  const drawArea = {
    x: rect.x + glideTheme.cellHorizontalPadding,
    y: rect.y + glideTheme.cellVerticalPadding,
    width: rect.width - 2 * glideTheme.cellHorizontalPadding,
    height: rect.height - 2 * glideTheme.cellVerticalPadding
  };
  if (column.sortable) {
    const sortIconWidth = 8;
    renderSortIcon({
      ctx,
      drawArea,
      sortIconWidth,
      sortModel,
      activeColor: muiTheme.palette.primary.main,
      columnId: column.id
    });
    renderHeaderTitle({ ctx, drawArea, spacing: sortIconWidth, columnName: column.columnName });
  } else {
    renderHeaderTitle({ ctx, drawArea, columnName: column.columnName });
  }
}
function renderHeaderTitle({ ctx, drawArea, spacing = 0, columnName }) {
  const columnNameMaxWidth = drawArea.width - spacing;
  const textCtx = new CanvasRenderingContext2DExtended(ctx);
  textCtx.fillTextWithEllipsis(columnName, columnNameMaxWidth, drawArea.x, drawArea.y + rowHeight / 2);
}
function renderSortIcon({ ctx, drawArea, sortIconWidth, sortModel, activeColor, columnId }) {
  const sortIconHeight = sortIconWidth / 2;
  let sortIconPoints = [
    { x: drawArea.x + drawArea.width, y: drawArea.y + drawArea.height / 2 },
    { x: drawArea.x + drawArea.width - sortIconWidth, y: drawArea.y + drawArea.height / 2 },
    { x: drawArea.x + drawArea.width - sortIconWidth / 2, y: drawArea.y + drawArea.height / 2 + sortIconHeight }
  ];
  if (sortModel[0]?.field === columnId) {
    ctx.fillStyle = activeColor;
    if (sortModel[0].sort === "asc") {
      sortIconPoints = [
        { x: drawArea.x + drawArea.width, y: drawArea.y + drawArea.height / 2 + sortIconHeight },
        { x: drawArea.x + drawArea.width - sortIconWidth, y: drawArea.y + drawArea.height / 2 + sortIconHeight },
        { x: drawArea.x + drawArea.width - sortIconWidth / 2, y: drawArea.y + drawArea.height / 2 }
      ];
    }
  }
  ctx.beginPath();
  ctx.moveTo(sortIconPoints[0].x, sortIconPoints[0].y);
  ctx.lineTo(sortIconPoints[1].x, sortIconPoints[1].y);
  ctx.lineTo(sortIconPoints[2].x, sortIconPoints[2].y);
  ctx.closePath();
  ctx.fill();
}
function renderSelectAllCell({ ctx, rect, theme, muiTheme, status }) {
  const size = 18;
  const posX = rect.x + rect.width / 2;
  const centerY = rect.y + rect.height / 2;
  const left = posX - size / 2;
  const top = centerY - size / 2;
  const radius = theme.roundingRadius ?? 4;
  if (status === "selected") {
    ctx.beginPath();
    roundedRect(ctx, left, top, size, size, radius);
    ctx.fillStyle = theme.accentColor;
    ctx.fill();
    const h = size / 2;
    ctx.beginPath();
    ctx.moveTo(left + size / 4.23, centerY - h + size / 1.97);
    ctx.lineTo(left + size / 2.42, centerY - h + size / 1.44);
    ctx.lineTo(left + size / 1.29, centerY - h + size / 3.25);
    ctx.strokeStyle = theme.bgCell;
    ctx.lineJoin = "round";
    ctx.lineCap = "round";
    ctx.lineWidth = 1.9;
    ctx.stroke();
  } else if (status === "indeterminate") {
    ctx.beginPath();
    roundedRect(ctx, left, top, size, size, radius);
    ctx.fillStyle = muiTheme.palette.secondary.main;
    ctx.fill();
    ctx.beginPath();
    ctx.moveTo(left + size / 3, centerY);
    ctx.lineTo(left + size * 2 / 3, centerY);
    ctx.strokeStyle = theme.bgCell;
    ctx.lineCap = "round";
    ctx.lineWidth = 1.9;
    ctx.stroke();
  } else {
    ctx.beginPath();
    roundedRect(ctx, left + 0.5, top + 0.5, size - 1, size - 1, radius);
    ctx.lineWidth = 1;
    ctx.strokeStyle = theme.textLight;
    ctx.stroke();
  }
}
export {
  renderHeaderCell,
  renderSelectAllCell
};
//# sourceMappingURL=headerCell.js.map
